<nz-modal
   nzWrapClassName="ncx-modal"
   [(nzVisible)]="addLabelsVisible"
   [nzContent]="modalContent"
   [nzFooter]="modalFooter"
   (nzOnCancel)="handleCancel()"
   [nzMaskClosable]="false">
   <ng-template #modalContent>
      <div [attr.data-component]="'@modals/add-labels'">
         <p class="header">{{ isNewLabel ? 'Add' : 'Edit' }} Labels</p>

         <div class="body">
            <section>
               <p class="form-label">Type</p>

               <div class="form-element">
                  <input
                     *ngIf="!isNewLabel"
                     nz-input
                     placeholder="Type of Label"
                     [(ngModel)]="typeOfLabel"
                     [disabled]="true" />

                  <nz-select
                     *ngIf="isNewLabel"
                     [(ngModel)]="selectedValue"
                     nzAllowClear
                     (ngModelChange)="changedType($event)"
                     nzPlaceHolder="Choose type of Label">
                     <nz-option
                        nzValue="markAs"
                        nzLabel="Mark As"></nz-option>
                     <nz-option
                        nzValue="status"
                        nzLabel="Status"></nz-option>
                  </nz-select>
               </div>
            </section>

            <section>
               <ng-container *ngIf="isNewLabel">
                  <p class="form-label">Label Name</p>
                  <div class="form-element">
                     <input
                        nz-input
                        placeholder="Label Name"
                        [(ngModel)]="labelName"
                        (ngModelChange)="changeLabelName($event)" />
                  </div>
               </ng-container>

               <ng-container *ngIf="!isNewLabel">
                  <p class="form-label">Labels</p>
                  <div class="form-element">
                     <button
                        nz-button
                        nz-dropdown
                        nzBlock
                        nzTrigger="click"
                        [nzDropdownMenu]="roleMenu">
                        Select
                        <i
                           nz-icon
                           nzType="down"></i>
                     </button>
                     <nz-dropdown-menu #roleMenu="nzDropdownMenu">
                        <ul nz-menu>
                           <li
                              nz-menu-item
                              *ngFor="let item of editLabels">
                              <label
                                 nz-checkbox
                                 nzValue="item.label"
                                 [ngModel]="!item.inActive"
                                 (ngModelChange)="changeLabelStatus($event, item)">
                                 {{ item.label }}
                              </label>
                           </li>
                        </ul>
                     </nz-dropdown-menu>
                  </div>
               </ng-container>
            </section>
         </div>
      </div>
   </ng-template>

   <ng-template #modalFooter>
      <button
         nz-button
         nzType="default"
         (click)="handleCancel()">
         Cancel
      </button>
      <button
         *ngIf="!isNewLabel"
         nz-button
         nzType="primary"
         (click)="handleOk()">
         Save Labels
      </button>
      <button
         *ngIf="isNewLabel"
         nz-button
         nzType="primary"
         (click)="addLabel()">
         Add Labels
      </button>
   </ng-template>
</nz-modal>
